const openCloseAccordionSlides = function(e){
    let parents = document.querySelectorAll('.main-product__accordion');
    if(e){
        let closest = e.target.closest('.main-product__accordion');
        closest.setAttribute('accordion-select', '');
        parents = document.querySelectorAll('.main-product__accordion[accordion-select]');
        closest.removeAttribute('accordion-select')
    }
    parents.forEach((parent) => {
        let openSlides = parent.querySelectorAll('.main-product__accordion-li[data-status="open"]');
        let ul = parent.querySelector('.main-product__accordion-ul');

        ul.setAttribute('data-transitioning', 'true')

        let liElement;
        let newStatus;
        if(e && e.target){
            liElement = e.target.closest('.main-product__accordion-li') ? e.target.closest('.main-product__accordion-li') : e.target;
            newStatus = liElement.getAttribute('data-status') == 'open' ? 'closed' : 'open';
        }

        let timeoutLength = openSlides.length > 0 && newStatus == "open" ? 1000 : 500;

        if(openSlides.length > 0){
            openSlides.forEach((openSlide) => {
                openSlide.setAttribute("data-status", 'closed');
                openSlide.querySelector('.main-product__accordion-body-container').style.height = "0"            
            })
        }

        const openSlide = function(){
            liElement.setAttribute('data-status', 'open');
            let liBody = liElement.querySelector('.main-product__accordion-body-container');
            let bodyHeight = parseFloat(window.Branch.functions.getStyle(liBody.querySelector('.main-product__accordion-body-inner-container'), 'height').replace('px', ''));
            liBody.style.height = `${bodyHeight}px`
        }

        setTimeout(() => {
            ul.setAttribute('data-transitioning', 'false')
        }, `${timeoutLength}`);


        if(newStatus == 'open' && e && e.target){
            if(openSlides.length > 0){ 
                setTimeout(() => {
                openSlide()
                }, "500");
            } else {
                openSlide()
            }
        }
    })
}

window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};

window.Branch.product.updateDiscountCodePrice = function(variant, product, origin, bundlePricingDataArray, placement) {
    let item = document.querySelector(`#main-product-item-${product.id}`);
    let priceData;

    if(origin == 'bundle-builder-pop-up'){
        priceData = bundlePricingDataArray.find(obj => Object.keys(obj).includes(`${variant.id}`))[`${variant.id}`];

    } else if(placement && placement == 'side-cart'){
        priceData = JSON.parse(document.querySelector(`#full-side-cart-addons-pricing-data`).innerText)[`${product.id}`][`${variant.id}`];

    } else {
        priceData = JSON.parse(document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`).innerText)[`${variant.id}`];
    }
    let originalPrice = priceData.opx == "" ? null : priceData.opx;
    let currentPrice = priceData.cpx;
    let discountMessage = priceData.dcmx == "" ? null : priceData.dcmx;

    if(origin == 'bundle-builder-pop-up'){
        let discount_multiplier = ((100 - parseInt(priceData.bdx))/100);
        originalPrice = priceData.opx == "" ? priceData.cpx : priceData.opx;
        currentPrice = priceData.cpx * discount_multiplier;
    }

    if(originalPrice == currentPrice){
        originalPrice = null;
    }

    let priceContainers = item.querySelectorAll('.main-product .main-product__title-review-price-container .price');
    if(priceContainers.length > 0){
        priceContainers.forEach((priceContainer) => {
            let priceParent = priceContainer.parentElement;
            priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').innerHTML = Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','');
        
            let retail = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) .retail');
            let dataRetail = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="retail"]');
            let offPecentage = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-percent"]');
            let offAmount = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-amount"]');
            let discountCodeOffPercent = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="discount-code-off-percent"]');
        
            if(originalPrice != null){
              var retailPrice = Shopify.formatMoney(originalPrice, Simplistic.formatMoney).replace('.00', '').replace(' ','');
              var percentDiscount = Math.round( (((originalPrice - currentPrice) * 100 ) / originalPrice) );
              var moneyDiscount = Shopify.formatMoney((originalPrice - currentPrice), Simplistic.formatMoney).replace('.00', '').replace(' ','');
                  
              
        
              if(discountMessage && discountMessage != null && discountCodeOffPercent){
                var modifiedMessage = discountMessage.replace('<p>',`<p>Save ${percentDiscount}% `)
                discountCodeOffPercent.innerHTML = modifiedMessage;
              }
        
              if(dataRetail){
                dataRetail.innerHTML = `${retailPrice}`;
            };

              if(retail){retail.setAttribute('data-visible', true)};
              if(offPecentage){offPecentage.innerHTML = `${percentDiscount}%`};
              if(offAmount){offAmount.innerHTML = moneyDiscount};
        
            } else {
                if(dataRetail){dataRetail.innerHTML = ''};
                if(retail){retail.setAttribute('data-visible', false)};
                if(offPecentage){offPecentage.innerHTML = ''};
                if(offAmount){offAmount.innerHTML = ''};
                if(discountCodeOffPercent){discountCodeOffPercent.innerHTML = ''};
            }
        
        })
    }
  };

window.Branch.product.initAccordion = function(){
    const accordions = document.querySelectorAll('.main-product .main-product__accordion:not([data-init="true"]');
    if(accordions.length > 0){
        accordions.forEach((accordion) => {
            accordion.setAttribute('data-init', true);
            const accordionSlides = accordion.querySelectorAll('.main-product__accordion-li');
            if(accordion && accordionSlides.length > 0){
                accordionSlides.forEach((accordionSlide) => {
                    accordionSlide.querySelector('.main-product__accordion-header-container').addEventListener("click", openCloseAccordionSlides);
                })
            }
        })
    }
}


const returnMaxHeight = function(colorSwatchHeads){
    let maxHeight = 0;
    colorSwatchHeads.forEach((colorSwatchHead) => {
        let colorSwatchHeadHeight = colorSwatchHead.offsetHeight;
        if(colorSwatchHeadHeight > maxHeight){
            maxHeight = colorSwatchHeadHeight;
        }
    })
    return maxHeight;
}

const largestMultipleBelow = function(number, divisor) {
    const remainder = number % divisor;
    return number - remainder;
}

const setCustomContainerWidth = function(colorSwatch){
    let custom_option_present = colorSwatch.closest('.swatches-container[data-custom-color-swatch-options="true"]') ? true : false;
    if(custom_option_present){
        let colorCustomSwatchContainers = colorSwatch.querySelectorAll('.custom-color-swatch-option__new-swatch-container, .custom-color-swatch-option__regular-swatch-container');

        colorCustomSwatchContainers.forEach((colorCustomSwatchContainer) => {
            colorCustomSwatchContainer.style.width = 'unset'
            setTimeout(() => {
                const finalNumber = largestMultipleBelow(colorCustomSwatchContainer.offsetWidth + 17, 47)
                colorCustomSwatchContainer.style.width = `${finalNumber - 17}px`
            }, 250)
        })
        
    }
}

window.Branch.product.customSwatchContainerResize = function(selector){
    let colorSwatches = document.querySelectorAll(`${selector} .swatches-container .swatches-container__color-swatches-container`);
    if(colorSwatches.length > 0){
        colorSwatches.forEach((colorSwatch) => {
            setCustomContainerWidth(colorSwatch);
        })
    }
}

window.Branch.product.initPreOrderSwatch = function(discountMessage, discountAmount, preOrderSwatches, productId, defaultCodeMessage){
    let displayPreorderSwatch = discountMessage == "" ? false : true;
    let discountMessageFull = '';
    let discountMessageMobile = ''
    let toolTipText = '';

    if(discountMessage != ""){
        discountMessageFull = discountMessage.replace('<p>', `<p>Save ${discountAmount}% `);
        discountMessageMobile = discountMessage.replace('with code', 'Code');
        toolTipText = defaultCodeMessage;
    }

    let preOrderSwatchData =  document.querySelector(`.pre-order-swatch-data[data-product-id="${productId}"]`) ? JSON.parse(document.querySelector(`.pre-order-swatch-data[data-product-id="${productId}"]`).innerText) : {};
    if(preOrderSwatchData && preOrderSwatchData['variant_level']){
        if(preOrderSwatchData['swatch_text'] && preOrderSwatchData['tooltip_text']){
            discountMessageFull = preOrderSwatchData['swatch_text'];
            discountMessageMobile = preOrderSwatchData['swatch_text'];
            if(discountMessageMobile.includes('% with code')){
                discountMessageMobile = `Code ${discountMessageMobile.split('with code ')[1]}`;
            } else if(discountMessageMobile.includes('% with ')){
                discountMessageMobile = `Code ${discountMessageMobile.split('with ')[1]}`;
            }
            toolTipText = preOrderSwatchData['tooltip_text'];
            displayPreorderSwatch = true;
        };
    };

    
    if(preOrderSwatches.length > 0 && displayPreorderSwatch == true){
        let preOrderHTML = `<p>
                                <span data-tooltip="${toolTipText}">
                                    <span class="pre-order-swatch__desktop">
                                        ${discountMessageFull.replaceAll('<p>', '').replaceAll('</p>', '')}
                                    </span>
                                    <span class="pre-order-swatch__mobile">
                                        ${discountMessageMobile.replaceAll('<p>', '').replaceAll('</p>', '')}
                                    </span>
                                    <svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-tooltip" viewBox="0 0 18 17"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.26191 16.8867C14.0714 16.8867 17.9702 13.1436 17.9702 8.52635C17.9702 3.90907 14.0714 0.166016 9.26191 0.166016C4.45243 0.166016 0.553574 3.90907 0.553574 8.52635C0.553574 13.1436 4.45243 16.8867 9.26191 16.8867ZM8.01518 8.62759C7.85935 8.77719 7.78143 8.9664 7.78143 9.19521V10.1984C7.78143 10.4273 7.85935 10.6209 8.01518 10.7793C8.17101 10.9289 8.3681 11.0037 8.60643 11.0037C8.84476 11.0037 9.04185 10.9289 9.19768 10.7793C9.35351 10.6209 9.43143 10.4273 9.43143 10.1984V9.71003C9.43143 9.69243 9.43601 9.67923 9.44518 9.67043L9.50018 9.64403C9.89435 9.58242 10.2564 9.48122 10.5864 9.34042C10.9256 9.19081 11.2189 8.9972 11.4664 8.75959C11.7231 8.51318 11.9202 8.22277 12.0577 7.88836C12.1952 7.54514 12.2639 7.15353 12.2639 6.71351C12.2639 6.12388 12.1127 5.59586 11.8102 5.12944C11.5077 4.66302 11.0998 4.29341 10.5864 4.0206C10.0823 3.73899 9.51393 3.59818 8.88143 3.59818C8.37726 3.59818 7.9006 3.69059 7.45143 3.87539C7.01143 4.0514 6.62643 4.30221 6.29643 4.62782C6.10393 4.81263 6.01685 5.01504 6.03518 5.23505C6.05351 5.45506 6.17268 5.64426 6.39268 5.80267C6.60351 5.95228 6.80976 6.00068 7.01143 5.94788C7.22226 5.88627 7.40101 5.79387 7.54768 5.67067C7.73101 5.52106 7.93268 5.40226 8.15268 5.31425C8.38185 5.22625 8.62476 5.18225 8.88143 5.18225C9.21143 5.18225 9.50476 5.24825 9.76143 5.38025C10.0273 5.51226 10.2335 5.69267 10.3802 5.92148C10.536 6.15029 10.6139 6.4143 10.6139 6.71351C10.6139 7.11832 10.5223 7.44394 10.3389 7.69035C10.1648 7.93676 9.92643 8.11717 9.62393 8.23157C9.32143 8.33717 8.98226 8.38998 8.60643 8.38998C8.3681 8.38998 8.17101 8.46918 8.01518 8.62759ZM7.91893 13.1686C8.0656 13.3006 8.27185 13.3666 8.53768 13.3666H8.71643C8.98226 13.3666 9.18393 13.3006 9.32143 13.1686C9.4681 13.0278 9.54143 12.8298 9.54143 12.5745V12.3501C9.54143 12.0949 9.4681 11.9013 9.32143 11.7693C9.18393 11.6285 8.98226 11.5581 8.71643 11.5581H8.53768C8.27185 11.5581 8.0656 11.6285 7.91893 11.7693C7.78143 11.9013 7.71268 12.0949 7.71268 12.3501V12.5745C7.71268 12.8298 7.78143 13.0278 7.91893 13.1686Z" fill="white"></path>
                                    </svg>
                                </span>
                            </p>`;
        preOrderSwatches.forEach((preOrderSwatch) => {
            preOrderSwatch.innerHTML = preOrderHTML;
            preOrderSwatch.setAttribute('data-initialized', true);
            preOrderSwatch.setAttribute('data-display', true);
            preOrderSwatch.setAttribute('data-tooltip-fallback', toolTipText);
            preOrderSwatch.setAttribute('data-text-fallback', discountMessageFull.replaceAll('<p>', '').replaceAll('</p>', '').replaceAll('<span data-sale="test">', '').replaceAll('</span>', ''));
            preOrderSwatch.setAttribute('data-text-fallback-mobile', discountMessageMobile.replaceAll('<p>', '').replaceAll('</p>', ''));
        });
    }
    
}

const bottomRowAddAttribute = function(colorSwatch){
    let lowestElementDistance = 0;
    let elementDistances = [];
    colorSwatch.querySelectorAll('.swatch').forEach((swatchUnit) => {
        let swatchElementsAll = swatchUnit.querySelectorAll('.swatch-element');
        swatchElementsAll.forEach((swatchElement) => {
            swatchElement.setAttribute('bottom-row', false);
            swatchElement.setAttribute('data-element-in-row-has-label', false);
            elementDistances.push(parseInt(swatchElement.getBoundingClientRect().top));
            if(swatchElement.getBoundingClientRect().top > lowestElementDistance) {
                lowestElementDistance = parseInt(swatchElement.getBoundingClientRect().top)
            }
        });

        let uniqelementDistances = [...new Set(elementDistances)];
        uniqelementDistances.forEach((distance) => {
            let distanceHasLabel = false;
            swatchElementsAll.forEach((swatchElement) => {
                if(parseInt(swatchElement.getBoundingClientRect().top) == distance) {
                    if(swatchElement.getAttribute('data-label') == "true"){
                        distanceHasLabel = true;
                    }
                }
            });

            swatchElementsAll.forEach((swatchElement) => {
                if(parseInt(swatchElement.getBoundingClientRect().top) == lowestElementDistance) {
                    swatchElement.setAttribute('bottom-row', true);
                };

                if(parseInt(swatchElement.getBoundingClientRect().top) == distance) {
                    swatchElement.setAttribute('data-element-in-row-has-label', distanceHasLabel);
                }
            })
        })    
    });
}

const setSwatchHeaderStyling = function(colorSwatchHeads, colorSwatch){
    let custom_option_present = colorSwatch.closest('.swatches-container[data-custom-color-swatch-options="true"]') ? true : false;
    let third_custom_option_present = colorSwatch.querySelectorAll('.custom-color-swatch-option__new-swatch-container[data-index="1"]').length > 0 ? true : false;

    if(custom_option_present == true){
        let customHeads = colorSwatch.querySelectorAll('.custom-color-swatch-option .head');
        let customHeadPrimary = colorSwatch.querySelector('.head.head--parent');
        let maxHeight = returnMaxHeight(customHeads);
        customHeads.forEach((customHead) =>{
            customHead.style.top = `-${maxHeight - 8}px`;
            if(customHead.offsetWidth != 0){
                customHead.closest('.custom-color-swatch-option').style.minWidth = `${customHead.offsetWidth + 2}px`
            }        
        });
        let colorSwatches = colorSwatch.querySelectorAll('.swatch');
        colorSwatches[0].style.marginTop = `${-16 + (maxHeight - 14)}px`;
        if(colorSwatches.length > 1){
            colorSwatches.forEach((loopColorSwatch, loopIndex) => {
                if(loopIndex > 0){
                    loopColorSwatch.style.marginTop = `${maxHeight + 10}px`;
                }
            })
        }
        customHeadPrimary.style.top = `${-14 - (maxHeight - 24)}px`;
    } else {
        let maxHeight = returnMaxHeight(colorSwatchHeads);
        colorSwatchHeads.forEach((colorSwatchHead) =>{
            if(colorSwatchHead.getAttribute('data-type') != 'tabs'){
                colorSwatchHead.style.top = `-${maxHeight + 12}px`;
                colorSwatchHead.closest('.swatch').style.minWidth = `${colorSwatchHead.offsetWidth + 2}px`
            }   
        });
        colorSwatch.style.marginTop = `${maxHeight - 8}px`;
    };
}

function checkElementHeight(colorSwatchHeads, colorSwatch) {
    var element = colorSwatchHeads[0];
    
    if (element.offsetHeight > 0) {
        setTimeout(function() {
            let tabsDisplay = document.querySelector('#swatches-test').getAttribute('data-test-active') == 'false' ? false : true;
            if(!tabsDisplay){
                setSwatchHeaderStyling(colorSwatchHeads, colorSwatch);
            }    
        }, 500);
    } else {
        setTimeout(function() { 
            checkElementHeight(colorSwatchHeads, colorSwatch);
        }, 500);
    }
}

window.Branch.product.resizeSwatchesHeader = function(parentSelector){
    setTimeout(function(){
        let colorSwatches = document.querySelectorAll(`${parentSelector} .swatches-container .swatches-container__color-swatches-container`);
        if(colorSwatches.length > 0){
            colorSwatches.forEach((colorSwatch) => {
                let colorSwatchHeads = colorSwatch.querySelectorAll('.swatch .head ');
                if(colorSwatchHeads.length > 1){
                    checkElementHeight(colorSwatchHeads, colorSwatch);
                }
                bottomRowAddAttribute(colorSwatch);
            })
        }
    },
    500)
  }

  window.Branch.product.formatSwatches = function(format_options){
   
    if(!format_options){
        format_options = {};

        format_options['swatches_selector'] = `.main-product .swatches-container__color-swatches-container`;
        format_options['swatches_container_parent_selector'] = '.swatches-container'
        format_options['swatch_width'] = 47;
        format_options['divider_width'] = 41;
    }

    const swatches = document.querySelectorAll(`${format_options.swatches_selector}`);
        swatches.forEach((swatch) => {
    swatch.removeAttribute('data-wrapped');
      let isQuickView = swatch.closest('.main-product[data-quick-view="true"]') ? true : false;
      let buttonWidth = 0
      if(format_options.not_hidden_button_container != null && swatch.closest(`${format_options.swatches_container_parent_selector}`).querySelectorAll(`${format_options.not_hidden_button_container}`).length > 0){
        buttonWidth = swatch.closest(`${format_options.swatches_container_parent_selector}`).querySelector(`${format_options.not_hidden_button_container}`).offsetWidth + 10;
      }
      if(format_options['button_width'] == 0){
        buttonWidth = 0;
      }
      let width = swatch.closest(`${format_options.swatches_container_parent_selector}`).offsetWidth - buttonWidth;
      if(isQuickView == true){
        let currentWindowWidth = window.Branch.functions.returnWindowWidth();
        width = currentWindowWidth >= 900 ? ((currentWindowWidth - 34) * 0.55) - 40 - 24 : currentWindowWidth - 80;
        if(currentWindowWidth >= 1014){
            width = (980 * 0.55) - 40 - 24;
        }
      }
      
      let numberOfSwatches = swatch.querySelectorAll('.swatch-element.color').length;
      
      if(numberOfSwatches > 0){
        let swatchWidth = swatch.closest('.swatches-container').getAttribute('data-display-type') == 'tabs' ? 69 : format_options.swatch_width;

        let dividerWidth = format_options.divider_width;
        let customSwatchUnits = swatch.querySelectorAll('.swatch.color[role="group"] .custom-color-swatch-option');  
        let widthNeededToBeOnOneLine = dividerWidth + (numberOfSwatches * swatchWidth);

        if(width > widthNeededToBeOnOneLine){
          swatch.setAttribute('data-wrapped', false)
        } else {
          swatch.setAttribute('data-wrapped', true)
        }

        if(customSwatchUnits.length > 0 && !swatch.closest('.main-product') && !swatch.closest('.variant-inspect')){
          let customNumberOfSwatches = 0;
          let swatchCustom = swatch.querySelector('.swatch.color[role="group"][data-custom-color-swatch-option="true"]')

          customSwatchUnits.forEach((customSwatchUnit) => {
            customNumberOfSwatches = customNumberOfSwatches + customSwatchUnit.querySelectorAll('.swatch-element.color').length
          })
           let customWidthNeededToBeOnOneLine = dividerWidth + (customNumberOfSwatches * swatchWidth);
           if(width > customWidthNeededToBeOnOneLine){
            swatchCustom.setAttribute('data-wrapped', false)
          } else {
            swatchCustom.setAttribute('data-wrapped', true)
          }
        }
      }


      if(swatch.getAttribute('data-init') == "false"){
        swatch.setAttribute('data-init', 'true');
      }
    });
  }

  window.Branch.product.updateVariantSwatchTitles = function(mainProductSwatches, variant, productId, variantTextReplacementMetafield){
    if(variant){
        mainProductSwatches.forEach((mainProductSwatch, index) => {
            let variantText = variant[`option${index + 1}`];
            if(variantText && variantText != ""){
            let optionVarNameSpans = mainProductSwatch.querySelectorAll('.head span.opt-var-name');
            if(mainProductSwatch.closest('.swatches-container') && mainProductSwatch.closest('.swatches-container__tab-outer-container')){
                optionVarNameSpans = mainProductSwatch.closest('.swatches-container__tab-outer-container').querySelectorAll('.head span.opt-var-name');
            }

            optionVarNameSpans.forEach((optionVarNameSpan) => {
                let variantTextStripped = window.Branch.functions.stripVariantText(variantText, variantTextReplacementMetafield);
                variantTextStripped = variantTextStripped.replace(/ ?inches/gi, "″");
                optionVarNameSpan.classList.add('active')
                optionVarNameSpan.innerHTML = window.Branch.functions.capitalizeWords(variantTextStripped);

                let optionVarTitleSpan = optionVarNameSpan.parentElement.querySelector('.head span.opt-var-title');
                if(optionVarTitleSpan){
                    let customColorSwatchData = document.querySelector(`#custom-color-swatch-data--${productId}`) ? JSON.parse(document.querySelector(`#custom-color-swatch-data--${productId}`).innerText) : null;
                    if(customColorSwatchData){
                    let variantTextHandleized = variantText.toLowerCase().replaceAll(' ', '-');
                    let variantTitleText = customColorSwatchData[`${variantTextHandleized}`];
                    optionVarTitleSpan.innerHTML = `${variantTitleText}: `;
                    }
                }
            })
            }
        })
    }
  }

  window.Branch.product.updateColorSwatchTabsSelectedIndicator = function(mainProductSwatches, variant, productId) {
    if(variant){
        let mainProductSwatchesIndex = 0;
        mainProductSwatches.forEach((mainProductSwatch, index) => {
            if(mainProductSwatch.closest(`body .swatches-container[data-product-id="${productId}"]`) && mainProductSwatch.classList.contains('color')){
                let colorsSelectedInfoSwatchesContainer = mainProductSwatch.closest('.swatches-container__tab-outer-container').querySelector('.swatches-container__colors_selected-info-swatches-container');
                if(colorsSelectedInfoSwatchesContainer){
                    if(colorsSelectedInfoSwatchesContainer.getAttribute('data-initialized') != 'true'){
                        let firstThreeOptions = Array.from(
                        mainProductSwatch.querySelectorAll('.swatch-element label[role="button"]')
                        )
                        .slice(0, 3)
                        .map(el => {
                            const colorClass = Array.from(el.classList).find(c => c.startsWith('color-'));
                            return colorClass || '';
                        })
                        .filter(Boolean)
                        .join(',');

                        colorsSelectedInfoSwatchesContainer.setAttribute('data-first-three-options', firstThreeOptions);
                    }
                    let firstThreeOptionsArray = colorsSelectedInfoSwatchesContainer.getAttribute('data-first-three-options').split(',');
                    let variantTextHandleized = variant[`option${mainProductSwatchesIndex + 1}`].toLowerCase().replace(/ /g,'-')
                    colorsSelectedInfoSwatchesContainer.querySelectorAll('.swatches-container__colors_selected-info-swatch').forEach((swatch, index)=> {
                        Array.from(swatch.classList).filter(c => c.startsWith('color-')).forEach(c => swatch.classList.remove(c));
                        if(index == 0) {
                            swatch.classList.add(`color-${variantTextHandleized}`);
                            firstThreeOptionsArray = firstThreeOptionsArray.filter(item => item !== `color-${variantTextHandleized}`);
                        } else {
                            swatch.classList.add(`${firstThreeOptionsArray[index - 1]}`);
                        }
                    })

                    if(colorsSelectedInfoSwatchesContainer.getAttribute('data-initialized') != 'true'){
                        colorsSelectedInfoSwatchesContainer.setAttribute('data-initialized', true);
                        if(colorsSelectedInfoSwatchesContainer.closest('.main-product') && colorsSelectedInfoSwatchesContainer.closest('.main-product').getAttribute('data-quick-view') == 'true') {
                            setTimeout(() => {
                            let firstButton = colorsSelectedInfoSwatchesContainer.closest('.main-product').querySelector('body #swatches-test:not([data-test-active="false"])  ~ #page .swatches-container .swatches-container__tab-button[data-clickable="true"]');
                            if(firstButton){
                                const clickEvent = new MouseEvent('click', {
                                    bubbles: true,
                                    cancelable: true,
                                    view: window
                                });
                                firstButton.dispatchEvent(clickEvent);
                            }
                            }, 500);
                        }
                    }
                }
                mainProductSwatchesIndex = mainProductSwatchesIndex + 1;
            }
        })
    }
  }

const initEpigraphButtons = function(){
    let epigraphInstances = document.querySelectorAll('epigraph-ar');
    if(epigraphInstances.length > 0){
        epigraphInstances.forEach((epigraphInstance) => {
            epigraphInstance.addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
            })
        })
    }
}

const formatReviewsNumber = function(){
    let reviewNumbers = document.querySelectorAll('.main-product .stamped-badge-caption');
    if(reviewNumbers.length > 0){
        reviewNumbers.forEach((reviewNumber) => {
            let numberOfReviews = parseInt(reviewNumber.getAttribute('data-reviews'));
            if(numberOfReviews > 999){
                let number = reviewNumber.childNodes[0];
                let formattedNumber = window.Branch.functions.numberWithCommas(numberOfReviews)
                number.nodeValue = `${formattedNumber}`
            }
        })
    }
}

window.Branch.product.formatPreOrderSwatch = function(id){
    let preOrderSwatches = document.querySelectorAll(`.main-product .pre-order-swatch:not([data-repositioned="true"])`);
    if(id){
        preOrderSwatches = document.querySelectorAll(`.main-product #main-product-item-${id} .pre-order-swatch:not([data-repositioned="true"])`);
    }

    if(preOrderSwatches.length > 0){
        preOrderSwatches.forEach((preOrderSwatch) => {
            let outerPrice = preOrderSwatch.closest('.price');
            let outerPriceWidth = outerPrice.closest('.price-installments-wrapper').offsetWidth; 
            let maxWidth = 0;

            if(outerPrice.querySelector('.price__discount-message')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.price__discount-message').offsetWidth);
            }

            if(outerPrice.querySelector('.retail')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.retail').offsetWidth) + 6;
            }

            if(outerPrice.querySelector('.deal')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.deal').offsetWidth);
            };

            // console.log('maxWidth', maxWidth)

            preOrderSwatch.setAttribute('data-adjusted', true);

            if(outerPriceWidth > 0){
                preOrderSwatch.style.maxWidth = `${outerPriceWidth - maxWidth}px`;
            }

            if(preOrderSwatch.hasAttribute('data-app') && preOrderSwatch.getAttribute('data-app') === 'true'){
                const swatchSpan = preOrderSwatch.querySelector('p > span');
                if(swatchSpan && !swatchSpan.hasAttribute('data-scroll-listener')){
                    swatchSpan.setAttribute('data-scroll-listener', 'true');
                    swatchSpan.style.cursor = 'pointer';
                    swatchSpan.addEventListener('click', function(e){
                        // Check if this click is from a popup/quick view context
                        const isInPopup = e.target.closest('.tingle-modal') ||
                                         e.target.closest('[data-quick-view="true"]') ||
                                         e.target.closest('.main-product[data-quick-view="true"]');

                        if(!isInPopup){
                            const targetSection = document.querySelector('.shopify-section.app-features');
                            if(targetSection){
                                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                        }
                    });
                }
            }
        })
    }
}

function findCheckedRadioIndex(elements) {
    return [...elements].findIndex(element => element.querySelector('input[type="radio"]:checked'));
}

window.Branch.product.returnFirstSecondVariant = function(product, origin, selector){
    let firstSecondVariant = [];
    let option_number = 1;
    let firstVariant = product.variants.find(obj => obj.available === true);
    let secondVariant;
    let secondSwatchIndex;
    let secondSwatchValue;
    let firstVariantSiblingSwatches;

    if(origin == "main-product") {
        firstVariantSiblingSwatches = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[0].querySelectorAll('.swatch-element');
    } else if(origin == "tile"){
        firstVariantSiblingSwatches = document.querySelector(`${selector}`) && document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0] ? document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0].querySelectorAll('.swatch-element') : null;
    } else {
        firstVariantSiblingSwatches = document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0].querySelectorAll('.swatch-element');
    }
    if(firstVariantSiblingSwatches){
        let checkedInputIndex = origin == "main-product" ? [...firstVariantSiblingSwatches].findIndex(element => element.querySelector('input[type="radio"]:checked')) : [...firstVariantSiblingSwatches].findIndex(element => element.classList.contains('selected'));
        
        if((checkedInputIndex + 2) < firstVariantSiblingSwatches.length){
            secondSwatchIndex = checkedInputIndex + 1;
            secondSwatchValue = firstVariantSiblingSwatches[secondSwatchIndex].getAttribute('data-value');
        } else if (firstVariantSiblingSwatches = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[1]) {
            option_number = 2;
            firstVariantSiblingSwatches = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[1].querySelectorAll('.swatch-element');
            checkedInputIndex = [...firstVariantSiblingSwatches].findIndex(element => element.querySelector('input[type="radio"]:checked'));
            if((checkedInputIndex + 2) < firstVariantSiblingSwatches.length){
                secondSwatchIndex = checkedInputIndex + 1;
                secondSwatchValue = firstVariantSiblingSwatches[secondSwatchIndex].getAttribute('data-value');
            }
        }

        secondVariant = product.variants.filter(obj => obj[`option${option_number}`] === secondSwatchValue);
        firstSecondVariant.push(firstVariant);
        firstSecondVariant.push(secondVariant[0]);
    }
    return firstSecondVariant;
}

const returnImageUrls = function(product, firstVariant, secondVariant, origin, widthIndicator, widthIndicatorLower){
    let imageUrlsArray = [];
    if(origin == "bundle-builder-sub-images" || origin == "bundle-builder-overlay-images"){        
        let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
        let firstVariantString = origin == "bundle-builder-sub-images" ? variant_data[`${firstVariant.id}`]['image_url'] : variant_data[`${firstVariant.id}`]['bundle_builder_image']['default'];
        imageUrlsArray.push(`${firstVariantString}${widthIndicator}`)
        imageUrlsArray.push(`${firstVariantString}${widthIndicatorLower}`)
        if(secondVariant){
            let secondVariantString = origin == "bundle-builder-sub-images" ? variant_data[`${secondVariant.id}`]['image_url'] : variant_data[`${secondVariant.id}`]['bundle_builder_image']['default'];
            imageUrlsArray.push(`${secondVariantString}${widthIndicator}`);
            imageUrlsArray.push(`${secondVariantString}${widthIndicatorLower}`)
        }
    } else {
        let firstVariantImagesSelectionString = origin == "main-product" ? firstVariant.featured_media.alt : undefined;
        let firstVariantImageUrlsArray = origin == "main-product" ? product.media.filter(obj => obj[`alt`] === firstVariantImagesSelectionString) : [firstVariant.featured_media];
        
        if(firstVariantImageUrlsArray.length > 0){
            firstVariantImageUrlsArray.forEach((url) => {
                if(origin == "main-product"){
                    imageUrlsArray.push(url.src  + widthIndicator)
                    imageUrlsArray.push(url.src  + widthIndicatorLower)
                } else {
                    imageUrlsArray.push(url.preview_image.src  + widthIndicator)
                    imageUrlsArray.push(url.preview_image.src  + widthIndicatorLower)
                }
            })
        }
        if(secondVariant && secondVariant.featured_media){
            let secondVariantImagesSelectionString = secondVariant.featured_media.alt;
            let secondVariantImageUrlsArray = origin != "tile" ? product.media.filter(obj => obj[`alt`] === secondVariantImagesSelectionString) : [secondVariant.featured_media];;
            if(secondVariantImageUrlsArray.length > 0){
                secondVariantImageUrlsArray.forEach((url) => {
                    if(origin != "tile"){
                        imageUrlsArray.push(url.src + widthIndicator)
                        imageUrlsArray.push(url.src + widthIndicatorLower)
                    } else {
                        imageUrlsArray.push(url.preview_image.src  + widthIndicator)
                        imageUrlsArray.push(url.preview_image.src  + widthIndicatorLower)
                    }
                })
            }
        }
    }
    


    return imageUrlsArray;
}

window.Branch.product.preloadImages = function(product, type, origin, selector) {
    let imageUrls = [];
    let sizes_string = "100vw";
    let image_selector

    if(origin == "bundle-builder-sub-images"){
        sizes_string = "(max-width:1167px) calc(50vw-275px), calc(((((100vw-84px))*0.55)-14px)/2)";
        image_selector = '.bundle-builder-gallery .bundle-builder-gallery__image.second_img_chair'
    } else if(origin == "bundle-builder-overlay-images"){
        sizes_string = "(max-width:900px) 100vw, (max-width:1167px) calc(100vw-538px), calc(((100vw-84px))*0.55)";
        image_selector = '.bundle-builder-gallery .bundle-builder-gallery__image.chairs'
    } else if(origin == "main-product" || origin == "product"){
        sizes_string = "(max-width:600px) 100vw, (max-width:900px) calc(100vw-48px), (max-width:1167px) calc(((100vw-48px))-490px), calc(((100vw-84px))*0.55)"
        image_selector = '.main-product .main-product__main-product-image'
    } else if(origin == 'toggle-header') {
        sizes_string = "(max-width: 599px) calc(((100vw - 52px) - (0.66666 * 24px)) / 1.66666), (max-width: 899px) calc(((100vw - 52px) - (1.66666 * 24px)) / 2.66666), (max-width: 1023px) calc((((100vw - 160px) * 0.6) - (0.3333 * 24px)) / 1.3333), (max-width: 1199px) calc((((100vw - 220px) * 0.6) - (1.3333 * 24px)) / 2.3333), (max-width: 1439px) calc((((100vw - 280px) * 0.7) - (2 * 24px)) / 3), calc(((1160px * 0.7) - (2 * 24px)) / 3)"
        image_selector = '.toggle-header-products-list__carousel-inner .product-tile .product-image-container img:not(.pre-loaded)'
    } else {
        sizes_string = "(max-width:600px) calc(100vw-48px), (max-width:840px) calc(((100vw-148px))/2), (max-width:900px) calc(((77.77vw-20px))/2), (max-width:1440px) calc(((77.77vw-40px))/3), calc(((1120px-40px))/3)"
        image_selector = '.product-tile .product-image-hover__image'
    }

    let currentSrcSet = document.querySelector(`${image_selector}`).getAttribute('srcset');

    const srcSetWidthsArray = currentSrcSet.match(/\d+w/g).map(s => parseInt(s));
    const viewportWidth = window.innerWidth;
    const devicePixelRatio = window.devicePixelRatio;

    const widthIndicatorArray = selectSrcset(srcSetWidthsArray, sizes_string, viewportWidth, devicePixelRatio);
    const widthIndicator = widthIndicatorArray[0];
    const widthIndicatorLower = widthIndicatorArray[1]


    if(type == "click" && origin == "main-product"){
        let tempImageUrls = product.media.filter(obj => obj.media_type === 'image').map(obj => obj.src);
        tempImageUrls.forEach((url) => {
            imageUrls.push(`${url}${widthIndicator}`);
            imageUrls.push(`${url}${widthIndicatorLower}`);
        })
    } else if(type == "click" && origin == "tile"){
        if(product.variants.length > 0){
            let variants_featured_media = product.variants.map(variant => variant.featured_media);
            let tempImageUrls = [...new Set(variants_featured_media.map(obj => obj.src))];
            tempImageUrls.forEach((url) => {
                imageUrls.push(`${url}${widthIndicator}`);
                imageUrls.push(`${url}${widthIndicatorLower}`);
            })
        }
    } else if(type == "click" && origin == "bundle-builder-overlay-images"){
        let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
        
        for (const [key, value] of Object.entries(variant_data)) {
            imageUrls.push(value['bundle_builder_image']['default'] + widthIndicator);
            imageUrls.push(value['bundle_builder_image']['default'] + widthIndicatorLower);     
            if(value['bundle_builder_image']['special-conditions'] && value['bundle_builder_image']['special-conditions'].length > 0){
                value['bundle_builder_image']['special-conditions'].forEach((specialCondition) => {
                    imageUrls.push(specialCondition['default-image-url'] + widthIndicator);
                    imageUrls.push(specialCondition['default-image-url'] + widthIndicatorLower);
                    if(specialCondition['option-matches'] && specialCondition['option-matches'].length > 0){
                        specialCondition['option-matches'].forEach((optionMatch) => {
                            imageUrls.push(optionMatch['image-url'] + widthIndicator);
                            imageUrls.push(optionMatch['image-url'] + widthIndicatorLower);
                        })
                    }
                })
            }
            }
    } else if(type == "click" && origin == "bundle-builder-sub-images"){
        if(product.variants.length > 0){
            const updateArrayWithBundleData = (product_variants, bundle_data, arr) => arr.push(...Object.values(product_variants).map(variant => bundle_data[variant.id]));
            let relevantBundleData = [];
            let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
            updateArrayWithBundleData(product.variants, variant_data, relevantBundleData);
            relevantBundleData.forEach((data_line) => {
                imageUrls.push(data_line['image_url'] + widthIndicator);
                imageUrls.push(data_line['image_url'] + widthIndicatorLower)
            })
        }
  } else if (origin == 'toggle-header') {
        let toggle_header_image_urls = [];
        let indicatorArray = [];
        document.querySelectorAll('.toggle-header-products-list__carousel-inner .product-tile .product-image-container img:not(.pre-loaded)').forEach(img => { if (!toggle_header_image_urls.includes(img.src)) toggle_header_image_urls.push(img.src); });

        indicatorArray.push(widthIndicator);
        indicatorArray.push(widthIndicatorLower);
        indicatorArray.forEach((indicator) => {
            toggle_header_image_urls.forEach((toggle_header_image_url) => {
                imageUrls.push(`${toggle_header_image_url}${indicator}`)
            })
        })
            
    } else {
            if(product.variants && product.variants.length > 1){
                let firstSecondVariant = window.Branch.product.returnFirstSecondVariant(product, origin, selector);
                let firstVariant = firstSecondVariant[0];
                let secondVariant = firstSecondVariant[1];

                if(firstVariant){
                    imageUrls = returnImageUrls(product, firstVariant, secondVariant, origin, widthIndicator, widthIndicatorLower);
                }
            } 
        }


    var loadedCount = 0;
    var totalImages = imageUrls.length;
    function checkAllImagesLoaded() {
        loadedCount++;
        // console.log('loadedCount', loadedCount)
        if (loadedCount === totalImages) {
            // console.log('all images pre-loaded');
            if(origin == 'toggle-header'){
                if(document.querySelector('.toggle-header__outer')){
                    document.querySelector('.toggle-header__outer').setAttribute('data-all-product-images-loaded', true)
                }
            }
        }
      }

    imageUrls.forEach(function(url) {

        if(url.includes('&') && !url.includes('?')){
            url = url.replace('&', '?');
        }

        var img = new Image();
        img.onload = checkAllImagesLoaded;
        img.onerror = checkAllImagesLoaded; // Handle errors loading images
        img.src = url;
      });
  }

  const selectSrcset = (srcsetArray, sizes, viewportWidth, devicePixelRatio) => {
    const srcsetCandidates = srcsetArray.map((item, index) => {
      const width= item;
      return { width: parseInt(width), index: index };
    });
  
    const evaluateCalc = (calcStr) => {
      const expression = calcStr.replace(/calc\(([^)]+)\)/g, (_, expr) => expr.replace(/(\d+(\.\d+)?)vw/g, (match, num) => `((${num} / 100) * ${viewportWidth})`)).replaceAll('px', '');
      return Function(`"use strict";return (${expression})`)();
    };
  
    const intendedSize = sizes.split(',').reverse().reduce((acc, size) => {
      let [condition, value] = size.trim().split(/\s+/);
      if(!value){
        value = condition
        condition = undefined
      }
      let maxWidthMatch = undefined;
      if(condition){
        maxWidthMatch = condition.match(/\((max-width:\s*(\d+)px)\)/);
      }
      if (!maxWidthMatch || maxWidthMatch && viewportWidth <= parseInt(maxWidthMatch[2])) {
        let vwValue = value.includes('vw') ? viewportWidth * (parseInt(value) / 100) : value;
        return value.includes('calc') ? evaluateCalc(value) : parseInt(vwValue);
      }
      return acc;
    }, viewportWidth);
  
    const requiredWidth = intendedSize * devicePixelRatio;
    const returnBestCandidate = (srcsetCandidates, requiredWidth) => srcsetCandidates.find(candidate => candidate.width > requiredWidth);

    let bestCandidatesArray = []

    let bestCandidate = returnBestCandidate(srcsetCandidates, requiredWidth);
    let bestCandidateString = bestCandidate ? `&width=${bestCandidate.width}` : `&width=${srcsetCandidates[srcsetCandidates.length - 1].width}`;
    let secondBestCandidateString = bestCandidate && srcsetCandidates[bestCandidate.index - 1] ? `&width=${srcsetCandidates[bestCandidate.index - 1].width}` : `&width=${srcsetCandidates[srcsetCandidates.length - 2].width}`;

    bestCandidatesArray.push(bestCandidateString)
    bestCandidatesArray.push(secondBestCandidateString)

    return bestCandidatesArray;
  };

window.Branch.product.initSwatchClickListener = function(product, isQuickView, type, selector){
    if(product.id){
        let swatchContainers = isQuickView ? document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container[data-clicked="false"]`) : document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container[data-clicked="false"], #mobile-sticky-atc`);
        if(type == 'tile'){
            swatchContainers = document.querySelectorAll(`${selector}`);
        }

        function clickHandler() {
        // Execute the callback function
        if(product.media.length > 0){
            let containerSelector = `.main-product .main-product__item#main-product-item-${product.id}`;
            window.Branch.product.preloadImages(product, 'click', type, containerSelector);
        }
        // Remove the click event listener after it's clicked once
        swatchContainers.forEach((swatchContainer) => {
            swatchContainer.removeEventListener('click', clickHandler);
          })
      }
      swatchContainers.forEach((swatchContainer) => {
        swatchContainer.addEventListener('click', clickHandler);
      })
    }
}

window.Branch.product.returnMatchCriteriaObject = function(variantMatchData, selectProductOptions, addOnProduct){
    let matchCriteriaObject = {};
    variantMatchData.forEach((variantMatch) => {
        let index = addOnProduct['options'].findIndex(item => item.toLowerCase() === variantMatch['add-on-option-name'].toLowerCase());
        if(index > -1){
            let nameMatch = variantMatch['option-name'].toLowerCase();
            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                variantMatch['non-identical-values-to-match'].forEach((nonIdenticalValueToMatch) => {
                    if(variantMatch['option-name'].toLowerCase() == nonIdenticalValueToMatch['value'].toLowerCase()){
                        nameMatch = nonIdenticalValueToMatch['add-on-value'].toLowerCase()
                    }
                }) 
            }
            let value = selectProductOptions[Object.keys(selectProductOptions).find(key => key.toLowerCase() === nameMatch)];

            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                let nonIdenticalValueToMatch = variantMatch['non-identical-values-to-match'].find((match) => match['value'] == value);
                if(nonIdenticalValueToMatch){
                    value = nonIdenticalValueToMatch['add-on-value']
                }
            }
            
            if(!matchCriteriaObject[`${index}`]){
                matchCriteriaObject[`${index}`] = [];
            }
            matchCriteriaObject[`${index}`].push(value);
        }
    })
    return matchCriteriaObject
}

window.Branch.product.returnMatchingVariantAddOn = function(selectedProduct, addOnHandle, addOnProduct, origin){
    let matchingVariantAddOn = addOnProduct['variants'][0];
    let selectedProductId = selectedProduct['product_id'];
    let bundleVariantMatchesData;

    // Check if global bundle_variant_matches_data is usable (not undefined, null, empty array, or empty object)
    let isGlobalDataUsable = typeof bundle_variant_matches_data !== 'undefined' &&
                             bundle_variant_matches_data !== null &&
                             !(Array.isArray(bundle_variant_matches_data) && bundle_variant_matches_data.length === 0) &&
                             !(typeof bundle_variant_matches_data === 'object' && Object.keys(bundle_variant_matches_data).length === 0);

    if (!isGlobalDataUsable) {
        if (origin == 'side-cart') {
            bundleVariantMatchesData = selectedProduct.addon_matches;
        } else if(origin == 'main-product'){
            bundleVariantMatchesData = document.querySelector('#bundle-variant-matches').innerHTML ? JSON.parse(document.querySelector('#bundle-variant-matches').innerHTML) : [];
        } else {
            // For bundle-builder and other contexts, check if selectedProduct has addon_matches (variant-level data)
            bundleVariantMatchesData = selectedProduct.addon_matches || [];
        }
    } else {
        bundleVariantMatchesData = bundle_variant_matches_data;
    }

    let variantMatchData;
    if(bundleVariantMatchesData){
        if(origin == 'main-product' || origin == 'side-cart' || !origin){
            // For main-product, side-cart, and bundle-builder (no origin), bundleVariantMatchesData is an array
            variantMatchData = bundleVariantMatchesData.length > 0 && bundleVariantMatchesData.find(item => item['add-on-handle'] === addOnHandle) ? bundleVariantMatchesData.find(item => item['add-on-handle'] === addOnHandle)['variant-matches'] : null;
        } else {
            // Legacy: for other origins, bundleVariantMatchesData might be keyed by product ID
            variantMatchData = bundleVariantMatchesData[selectedProductId] && bundleVariantMatchesData[selectedProductId].find(item => item['add-on-handle'] === addOnHandle) ? bundleVariantMatchesData[selectedProductId].find(item => item['add-on-handle'] === addOnHandle)['variant-matches'] : null;
        }
    }

    if(variantMatchData){
        let selectProductOptions = origin == 'side-cart' ? selectedProduct['options'] : JSON.parse(selectedProduct['options'].replace(/'/g, '"'));

        let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(variantMatchData, selectProductOptions, addOnProduct);

        let matchingVariant = addOnProduct['variants'].find(variant =>
            Object.entries(matchCriteriaObject).every(([index, values]) =>
                values.includes(variant.options[index])
            )
        );

        if(matchingVariant){
            matchingVariantAddOn = matchingVariant;
        }
    }

    return matchingVariantAddOn;
}

window.Branch.product.selectCorrectAddon = function(container, isAddOnsTab, productsArray, origin){
    let addOnId = parseInt(container.querySelector('.main-product .add-to-cart-form').getAttribute('data-product-id'));
    let addOnHandle = container.querySelector('.main-product .add-to-cart-form .select-variant').getAttribute('data-handle');
    let addOnProduct = origin == 'main-product' || origin == 'side-cart' ? productsArray[`${addOnId}`] : productsArray.find(product => product.id === addOnId);

    let productInputs = document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] .swatches-container .swatch-element input[type=radio]`);
    let selectInput = document.querySelector(`.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] input#product-${addOnId}-variant`);
    let productSelector = `.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] .swatches-container`;

   if(isAddOnsTab == true){
    let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];



    let matchFound = false;
    selectedChairDeskProducts.forEach((selectedProduct) => {
        if(matchFound == false){
            let selectedProductAddons = product_data[`${selectedProduct[`product_id`]}`]['addon_handles'].split(',');

            if (selectedProductAddons.some(e => e.trim() == addOnHandle)) {
                matchFound = true;
                let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct);
                window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'bundle-builder-pop-up', addOnProduct, bundlePricingDataArray);

                /* Check if variant is a bundle product, and if so update the 'bundle-products' input */

                if(variant_data[newProductAddOn.id][`constituents`] && JSON.parse(variant_data[newProductAddOn.id][`constituents`].replace(/'/g, '"')).length > 0){
                    window.Branch.product.updateOldStyleBundle(newProductAddOn.id, addOnId , "bundle-builder")
                }          
              }
        }
    })
   } else if(origin == "main-product"){
    let selectedProduct = {};
    let options_string = '';
 
    if(selected_main_product.selected_variant.option1){
        options_string = `'${selected_main_product.options[0]}': '${selected_main_product.selected_variant.option1}'`;
    }
    if(selected_main_product.selected_variant.option2){
        options_string = `${options_string}, '${selected_main_product.options[1]}': '${selected_main_product.selected_variant.option2}'`;
    }
    if(selected_main_product.selected_variant.option3){
        options_string = `${options_string}, '${selected_main_product.options[2]}': '${selected_main_product.selected_variant.option3}'`;
    }
    options_string = `{ ${options_string} }`;

    selectedProduct['options'] = `${options_string}` 
    selectedProduct['product_id'] = selected_main_product.id;
    selectedProduct['variant_id'] = `${selected_main_product.selected_variant.id}`


    if(addOnProduct){
        let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct, origin);
        window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'main-product-pop-up', addOnProduct, undefined);
    }

   }  else if(origin == "side-cart"){
    let selectedProductId = document.querySelector(`#side-cart .cart-addons .item`).getAttribute('data-main-product-variant')
    let selectedProduct = JSON.parse(document.querySelector(`#variant_data-side-cart`).innerText)[`${selectedProductId}`];
    let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct, origin);
    
    // console.log('selectedProduct', selectedProduct)

    window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'main-product-pop-up', addOnProduct, undefined, 'side-cart');
   }
   else {
    let newProductAddOn = addOnProduct['variants'][0];
    window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'bundle-builder-pop-up', addOnProduct, bundlePricingDataArray);

    /* Check if variant is a bundle product, and if so update the 'bundle-products' input */

    if(variant_data[newProductAddOn.id][`constituents`] && JSON.parse(variant_data[newProductAddOn.id][`constituents`].replace(/'/g, '"')).length > 0){
        window.Branch.product.updateOldStyleBundle(newProductAddOn.id, addOnId , "bundle-builder")
    }  
   }
   if(selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container') && selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container').getAttribute('data-initialized') == 'false'){
        selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container').setAttribute('data-initialized', true);
    }
};

window.Branch.product.updateAddonTile = function(addonsContainerItem, matchingVariant, type){
    addonsContainerItem.setAttribute('data-display-variant', `${matchingVariant.id}`);
    let variantPricingSelector = type && type == 'side-cart' ? '.cart-items' : ''

    /* Update addon tile image */
    let image = addonsContainerItem.querySelector(`.addon-img img:not(.addons_lifestyle-image)`);
    let addonProductId = parseInt(addonsContainerItem.querySelector(`input.checkbox-custom`).getAttribute('data-addon-id'))
 
    image.setAttribute('src', matchingVariant.featured_image.src)
    image.setAttribute('data-src', matchingVariant.featured_image.src)

    image.setAttribute('srcset', window.Branch.functions.returnSrcSet(matchingVariant.featured_image.src))

    /* Update addon tile price */
    let variantPricing;
    if(type == 'side-cart'){
        variantPricing = JSON.parse(document.querySelector(`#full-side-cart-addons-pricing-data`).innerText)[`${addonProductId}`];

    } else {
        variantPricing = JSON.parse(document.querySelector(`#full-pdp-addons-pricing-data`).innerText)[`${addonProductId}`];
    }
    
    let variantPrice = variantPricing[`${matchingVariant.id}`];
    
    let currentPriceRatio = variantPrice.cpx * parseInt(addonsContainerItem.getAttribute('data-quantity-ratio'))
    let originalPriceRatio = variantPrice.opx * parseInt(addonsContainerItem.getAttribute('data-quantity-ratio'))

    if(variantPrice.bdx && variantPrice.bdx > 0){
        currentPriceRatio = currentPriceRatio * ((100 - variantPrice.bdx)/100);
        if(originalPriceRatio == 0){
            originalPriceRatio = variantPrice.cpx;
        }
    }

    // console.log('addonsContainerItem', addonsContainerItem);

    const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(currentPriceRatio, originalPriceRatio, 0, '', addonsContainerItem.getAttribute('data-product-handle'));
    currentPriceRatio = codeDiscountData.currentPrice;
    originalPriceRatio = codeDiscountData.originalPrice;

    let priceString = `+${Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`
    let originalPriceString = `${Shopify.formatMoney(originalPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`

    if(addonsContainerItem.getAttribute('data-modification-price-replacement-text')){
        priceString = addonsContainerItem.getAttribute('data-modification-price-replacement-text')
    }

    if(addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')){
        originalPriceString = addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')
    }

    if(addonsContainerItem.getAttribute('data-modification-price-replacement-text') && !addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')){
        originalPriceString = `+${Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`;
    }

    addonsContainerItem.querySelector('span.addon-price').innerHTML = priceString;
    if(addonsContainerItem.querySelector('span[data-price="retail"]')){
        addonsContainerItem.querySelector('span[data-price="retail"]').innerHTML = originalPriceString;
        if(currentPriceRatio < originalPriceRatio){
            addonsContainerItem.querySelector('.price .retail').setAttribute('data-visible', true);
        } else {
            addonsContainerItem.querySelector('.price .retail').setAttribute('data-visible', false);
        }
    }
}

const updateAddonQuantity = function(container, addOnData, origin){
    let addOnId = parseInt(container.querySelector('.main-product .add-to-cart-form').getAttribute('data-product-id'));
    let quantityRatio = 1;
    if(origin == "side-cart" && document.querySelector(`#side-cart .cart-addons input[data-addon-id="${addOnId}"]`)){
        quantityRatio = parseInt(document.querySelector(`#side-cart .cart-addons input[data-addon-id="${addOnId}"]`).closest('.item').getAttribute('data-quantity-ratio'))
     } else if(document.querySelector(`.main-product .addons__container .addons .item input[data-addon-id="${addOnId}"]`)){
        quantityRatio = parseInt(document.querySelector(`.main-product .addons__container .addons .item input[data-addon-id="${addOnId}"]`).closest('.item').getAttribute('data-quantity-ratio'));
     }
    container.querySelector('.main-product__item').setAttribute('data-quantity-ratio', quantityRatio);
    if(quantityRatio > 1){
        let currentTitle = container.querySelectorAll('.main-product__title h1')[0].innerHTML;
        container.querySelectorAll('.main-product__title h1').forEach((mainTitle) => {
            mainTitle.innerHTML = `${currentTitle} (x${quantityRatio})`
        });
    }

    let bundle = false;
    if(addOnData && addOnData[`${addOnId}`] && addOnData[`${addOnId}`].tags && addOnData[`${addOnId}`].tags.length > 0){
        if(addOnData[`${addOnId}`].tags.indexOf("bundle") !== -1)  {
            bundle = true;
        }
    }

    if(origin == "side-cart"){
        let clickSpan = container.querySelector('.addon-add-btn .content-available span');
        if(clickSpan){
            clickSpan.setAttribute('onclick', `addToCartAddOns(${addOnId}, ${bundle}, ${quantityRatio})`)
        }

    } 
}

window.Branch.product.quickViewUpdateOnOpen = function(modal, container, origin, isAddOnsTab){
    container.setAttribute('data-initialized', true);
    let closeButton = container.querySelector('.tingle-modal__close');
    let modalBox = container.querySelector('.tingle-swatch-modal-box');

    if(modalBox){modalBox.appendChild(closeButton)};

    if(origin == 'bundle-builder-form' && products && products.length > 0){
        let atc_button = container.querySelector('#bundle-builder-addon');
        if(atc_button){
        window.Branch.product.selectCorrectAddon(container, isAddOnsTab, products);

        atc_button.addEventListener('click', function(e){
        e.preventDefault();
        let selectElement = container.querySelector('select.select-variant');
        let productId = parseInt(container.querySelector('form.add-to-cart-form').getAttribute('data-product-id'));
        window.Branch.bundle.handleAddOnClick(parseInt(selectElement.value), productId, selectElement.getAttribute('data-handle'));
        modal.close();
        })
        }
    } else if(origin == 'comparison-chart' && document.querySelector('body.template-page-bundles')){
        window.Branch.bundle.updateComparisonChart(container.querySelector('.comparison-chart-section'));
        
    } else if(origin == 'main-product'){
        let productId = parseInt(document.querySelector(`.main-product[data-quick-view="false"] .main-product__item`).getAttribute('id').replaceAll('main-product-item-', ''));
        let addOnData = document.querySelector(`#add_on_product_data--${productId}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${productId}`).innerHTML) : {};
        if(Object.values(addOnData).length > 0){
            updateAddonQuantity(container, addOnData, origin)
            window.Branch.product.selectCorrectAddon(container, isAddOnsTab, addOnData, origin);
        }
    } else if(origin == 'side-cart'){
        let addOnData = document.querySelector(`#add_on_product_data-side-cart`) ? JSON.parse(document.querySelector(`#add_on_product_data-side-cart`).innerHTML) : {};
        // console.log('addOnData', addOnData)
        if(Object.values(addOnData).length > 0){
            updateAddonQuantity(container, addOnData, origin)
            window.Branch.product.selectCorrectAddon(container, isAddOnsTab, addOnData, origin);    
        }
    }
}

const insertGalleryLoadingOverlay = function(selected_variant, product){
    let img_url = selected_variant['featured_image'];
    if(img_url){
        const galleryLoadingOverloadContainer = document.createElement("div");
        galleryLoadingOverloadContainer.classList.add('gallery-loading-overlay-container');
        let galleryLoadingOverloadInnerHTML = `
        <div class="gallery-loading-overlay-container-inner">
            <img
            srcset="${img_url.src}&width=180"
            width="540"
            height="540"
            class="gallery-loading-overlay-container-image"
            alt="${img_url.alt}"                      
            loading="eager"       
        >
        </div>
        `;
        galleryLoadingOverloadContainer.innerHTML = galleryLoadingOverloadInnerHTML;
        let gallery = document.querySelector(`.main-product .main-product-gallery[data-product-id="${product.id}"]`)
        gallery.appendChild(galleryLoadingOverloadContainer);
    }
}

window.Branch.product.selectVariantOnLoad = function(productId, selected_variant, productInputs, selectInput, productSelector, type, product, bundlePricingDataArray, placement){
    if (productInputs.length > 0) {
        productInputs.forEach((productInput) => {
            var $input = productInput;
            var name = productInput.getAttribute('name') + '-' + productId;
            $input.setAttribute('name', name);
        });
    }

    if(type == "bundle-builder-pop-up" || type == 'main-product-pop-up'){
        window.Branch.product.updateDiscountCodePrice(selected_variant, product, type, bundlePricingDataArray, placement);
        insertGalleryLoadingOverlay(selected_variant, product);
    }

    selected_variant.options.forEach(function(option, index) {
        var swatch_selector = '[data-option-index="' + index + '"] .swatch-element[data-value="' + option + '"]';

        if (document.querySelector(productSelector)) {
            var $swatch = document.querySelector(productSelector).querySelector(swatch_selector);
            if ($swatch != null) {
                if(type == 'bundle-builder-form'){
                    $swatch.classList.add('selected');
                }
                else {
                    $swatch.querySelector('input[type="radio"]').checked = true;
                }
            }
        }
    });
    

    selectInput.setAttribute('value', selected_variant.id);
    selectInput.value = selected_variant.id;

    selectElement = selectInput.parentElement.querySelector('select.select-variant');
    if(selectElement){
        selectElement.value = `${selected_variant.id}`;
    }

    let selectors = selectInput.closest('.add-to-cart-form') ? selectInput.closest('.add-to-cart-form').querySelectorAll(".single-option-selector") : [];

    if(selectors.length > 0){
        if(selected_variant.options[0] && selectors[0]){
            selectors[0].value = selected_variant.options[0];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[0].dispatchEvent(event);
        }

        if(selected_variant.options[1] && selectors[1]){
            selectors[1].value = selected_variant.options[1];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[1].dispatchEvent(event);
        }

        if(selected_variant.options[2] && selectors[2]){
            selectors[2].value = selected_variant.options[2];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[2].dispatchEvent(event);
        }
    }
}

const repositionPromoSwatchesContainer = function() {
    const swatchesTest = document.querySelector('#swatches-test');
    if (!swatchesTest) return;

    // console.log('repositionPromoSwatchesContainer')

    const addToCartForm = document.querySelector('.main-product .add-to-cart-form');
    const addonsPosition = swatchesTest.getAttribute('data-addons-position');

    // console.log('addonsPosition', addonsPosition, 'here', addToCartForm.getAttribute('data-addons-present'))

    if (swatchesTest.getAttribute('data-test-active') == "true" && addToCartForm && addToCartForm.getAttribute('data-addons-present') === 'true') {
        if (addonsPosition === 'outside_tabs') {
            
            const swatchesContainer = document.querySelector('.main-product .swatches-container__tab-outer-container[data-type="fake-promo-swatch"]');
            if (swatchesContainer) {
                swatchesContainer.setAttribute('data-shifted', 'false');
            }
        } else if (addonsPosition === 'within_tabs') {
            const swatchesContainer = document.querySelector('.main-product .swatches-container__tab-outer-container[data-type="fake-promo-swatch"]');
            const addonsContainer = document.querySelector('.main-product .swatches-container__tab-outer-container[data-type="addons"]');

            // console.log('he!', swatchesContainer, addonsContainer)

            if (swatchesContainer && addonsContainer) {
                addonsContainer.parentNode.insertBefore(swatchesContainer, addonsContainer);
                swatchesContainer.setAttribute('data-shifted', true);
            }
        }
    }

    // Set up MutationObserver to watch for data-addons-position changes
    if (!swatchesTest.hasAttribute('data-observer-initialized')) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-addons-position') {
                    repositionPromoSwatchesContainer();
                }
            });
        });

        observer.observe(swatchesTest, {
            attributes: true,
            attributeFilter: ['data-addons-position']
        });

        swatchesTest.setAttribute('data-observer-initialized', 'true');
    }
};

const updateSwatchModalHeight = function(modalBox, swatchData) {
    // If swatchData is not provided, try to get it from global scope or skip
    if(!swatchData && typeof window.currentSwatchElementsData !== 'undefined'){
        swatchData = window.currentSwatchElementsData;
    }

    if(modalBox && swatchData){
        const swatchValueElement = modalBox.querySelector('.swatch-modal__swatch-value');
        const infoContainers = modalBox.querySelectorAll('.swatch-modal__swatch-info-container');

        if(swatchValueElement && infoContainers.length > 0){
            let maxHeight = 0;
            let minHeight = Infinity;
            const originalText = swatchValueElement.textContent;

            // Loop through all swatch data entries to find the maximum and minimum heights
            Object.entries(swatchData).forEach(function(entry, index){
                const formattedValue = entry[1].option_value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

                // Temporarily set the text to measure height
                swatchValueElement.textContent = formattedValue;
                const height = swatchValueElement.offsetHeight;

                if(height > maxHeight){
                    maxHeight = height;
                }
                if(height < minHeight){
                    minHeight = height;
                }
            });

            // Restore original text
            swatchValueElement.textContent = originalText;

            // Only apply height adjustments if heights are not all the same
            if(maxHeight !== minHeight){
                // Set all info containers to the maximum height
                infoContainers.forEach(function(container){
                    container.style.height = maxHeight + 'px';
                });

                // Set the parent swatch-modal-box height based on window width
                if(window.innerWidth < 576){
                    modalBox.style.height = `calc(100vw - (2 * 24px) - 8px + ${maxHeight}px)`;
                } else {
                    modalBox.style.height = (528 + maxHeight + 'px');
                }
            }
        }
    }
};

const checkSizeSwatchesInline = function() {
    const swatchContainers = document.querySelectorAll('.swatches-container[data-type=main-product] .swatch.size .swatch-tab-inner');

    swatchContainers.forEach(container => {
        const swatchElements = container.querySelectorAll('.swatch-element');

        if (swatchElements.length === 0) {
            container.setAttribute('data-size-swatches-inline', 'false');
            return;
        }

        const originalStyle = container.style.cssText;
        container.style.display = 'flex';
        container.style.flexWrap = 'nowrap';
        container.style.overflow = 'hidden';

        let totalWidth = 0;
        let canDisplayInline = true;

        swatchElements.forEach(element => {
            const elementStyle = window.getComputedStyle(element);
            const elementWidth = element.offsetWidth +
                               parseFloat(elementStyle.marginLeft) +
                               parseFloat(elementStyle.marginRight);
            totalWidth += elementWidth;
        });

        const containerWidth = container.offsetWidth;
        canDisplayInline = totalWidth <= containerWidth;

        container.style.cssText = originalStyle;

        container.setAttribute('data-size-swatches-inline', canDisplayInline.toString());
    });
};

const mainProductReformat = function(){
    openCloseAccordionSlides();
    window.Branch.product.formatSwatches();
    window.Branch.product.resizeSwatchesHeader(`.main-product`);
    window.Branch.product.customSwatchContainerResize(`.main-product`);
    window.Branch.product.formatPreOrderSwatch();
    repositionPromoSwatchesContainer();
    checkSizeSwatchesInline();
}

const initMainProductSection = function(){
    window.Branch.product.initAccordion();
    let firstAccordionHeader = document.querySelector('.main-product__accordion .main-product__accordion-li[data-index="0"] .main-product__accordion-header-container');

    if (firstAccordionHeader) {
        const onScroll = function() {
            firstAccordionHeader.click();
            window.removeEventListener('scroll', onScroll);
        };
        window.addEventListener('scroll', onScroll);
    }

    const addons = document.querySelector(".main-product .addons__container");
    let originalParent = null;
    let originalNextSibling = null;

    // Function to move addons below message
    function moveAddonsBelow() {
        // console.log('moveAddonsBelow!')
        const message = document.querySelector(".main-product .msbd-message");

        if (addons && message && addons.getAttribute("data-addons-below-cta-moved") !== "true") {
            // Store original position before moving
            originalParent = addons.parentNode;
            originalNextSibling = addons.nextSibling;

            message.insertAdjacentElement("afterend", addons);
            addons.setAttribute("data-addons-below-cta-moved", "true");
            // console.log('move!')
            setTimeout(function(){
                window.Branch.addons.initAddonStyling('pdp', parseInt(addons.getAttribute('data-id')), 'repos');
            }, 500)
        }

    }

    // Function to restore addons to original position
    function restoreAddonsPosition() {
        if (addons && addons.getAttribute("data-addons-below-cta-moved") === "true" && originalParent) {
            if (originalNextSibling) {
                originalParent.insertBefore(addons, originalNextSibling);
            } else {
                originalParent.appendChild(addons);
            }
            addons.removeAttribute("data-addons-below-cta-moved");
                window.Branch.addons.initAddonStyling('pdp', parseInt(addons.getAttribute('data-id')), 'repos');

        }
    }


    // Initial positioning
    if (addons && document.querySelector('#swatches-test').getAttribute("data-addons-below-cta") === "true") {
        moveAddonsBelow();
    }

    // Observer to watch for attribute changes on body
    if (addons) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes" && mutation.attributeName === "data-addons-below-cta") {
                    const currentValue = document.querySelector('#swatches-test').getAttribute("data-addons-below-cta");

                    if (currentValue === "true") {
                        moveAddonsBelow();
                    } else if (currentValue === "false") {
                        restoreAddonsPosition();
                    }
                }
            });
        });

        observer.observe(document.querySelector('#swatches-test'), {
            attributes: true,
            attributeFilter: ["data-addons-below-cta"]
        });
    }

}

window.Branch.product.updateOldStyleBundle = function(variant_id, product_id , origin){
    if(origin == "bundle-builder"){
        let constituentsArrayString = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML)[`${variant_id}`]['constituents'];
        let constituentsArray = JSON.parse(constituentsArrayString.replace(/'/g, '"'));
        let bundleInput = document.querySelector(`#main-product-item-${product_id} .add-to-cart-form .bundle-products`);
        if(bundleInput){
            bundleInput.value = JSON.stringify(constituentsArray);
            bundleInput.setAttribute('value', JSON.stringify(constituentsArray));
        }
    }
}

const checkIfIncompatible = function(product, variant, selectedAddon, addOnVariantMatches, addOnProduct, addOnProductHandle, variantMatches){
    let mismatched = true;
    let currentAddOnVariant = Object.values(addOnProduct.variants).find(entry => entry['id'] === selectedAddon['variantId']);
    let productOptions = addOnProduct.options.map(name => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
    let productOptionValues = currentAddOnVariant.options;
        
    if(variantMatches && mismatched == true){
        let matchesFullfilled = 0;
        let nonCompulsoryMatchConditions = 0;
        let nonCompulsoryMatchConditionsMet = false;

        variantMatches.forEach((variantMatch) => {
            if(variantMatch['match-not-required-if-other-options-match'] == true) {
                nonCompulsoryMatchConditions = nonCompulsoryMatchConditions + 1;
            }
        });
        variantMatches.forEach((variantMatch) => {
            if(variantMatch['non-compulsory-match'] == true){
                matchesFullfilled = matchesFullfilled + 1
            } else {
                productOptions.forEach((productOption, index) => {
                    if(variantMatch['add-on-option-name'].toLowerCase().replace(' ', '-') == productOption){
                        let value = productOptionValues[index];
                        let optionIndex = product['options'].findIndex(item => item.toLowerCase() === variantMatch['option-name'].toLowerCase());
                        let variantOptionValue = variant.options[optionIndex]
                        let matchValue = variantOptionValue;

                            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                                let productOptionValue = productOptionValues[`${index}`].replaceAll('@', ',');
                                variantMatch['non-identical-values-to-match'].forEach((nonIdenticalMatch) => {
                                    if(nonIdenticalMatch['value'] == variantOptionValue && nonIdenticalMatch['add-on-value'] == productOptionValue){
                                        matchValue = nonIdenticalMatch['add-on-value'];
                                        matchesFullfilled = matchesFullfilled + 1;
                                    }
                                })
                            } else if(value === matchValue){
                                if(variantMatch['match-not-required-if-other-options-match'] == true && nonCompulsoryMatchConditionsMet == false){
                                    matchesFullfilled = matchesFullfilled + nonCompulsoryMatchConditions;
                                    nonCompulsoryMatchConditionsMet = true;
                                } else if(!variantMatch['match-not-required-if-other-options-match']) {
                                    matchesFullfilled = matchesFullfilled + 1;
                                }
                            }                 
                    }
                })
            }
        })

        if(matchesFullfilled >= variantMatches.length){
            mismatched = false;
        }
        // console.log('mismatched', mismatched, 'matchesFullfilled', matchesFullfilled, 'variantMatches.length', variantMatches.length)
    }
    return mismatched;
}

window.Branch.product.updateSelectedAddons = function(product, variant){
    let selectedAddons = document.querySelector('#addon-products-for-atc') && document.querySelector('#addon-products-for-atc').getAttribute('value') ? JSON.parse(document.querySelector('#addon-products-for-atc').getAttribute('value')) : [];
    if(selectedAddons.length > 0){
        let matchesData = document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`) && document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML ? JSON.parse(document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML) : [];
        let addOnData = document.querySelector(`#add_on_product_data--${product.id}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${product.id}`).innerHTML) : {};
        let msbdData = document.querySelector(`#variant_ship_date_metafield_values--${product.id}`) ? JSON.parse(document.querySelector(`#variant_ship_date_metafield_values--${product.id}`).innerHTML) : {};
        let selectProductOptions = {};
        if(product.options.length > 0){
            product.options.forEach((option, index) => {
            let value = variant.options[index];
            selectProductOptions[`${option}`] = value; 
            })
        }
        if(matchesData.length > 0 && Object.values(addOnData).length > 0){
            selectedAddons.forEach((selectedAddon, selectedAddonIndex) => {
                let addOnProduct = Object.values(addOnData).find(entry => entry['handle'] === selectedAddon['productHandle']);
                let addonProductMatchData = matchesData.find(entry => entry['add-on-handle'] === selectedAddon['productHandle']) ? matchesData.find(entry => entry['add-on-handle'] === selectedAddon['productHandle'])[`variant-matches`] : [];
                let incompatible = checkIfIncompatible(product, variant, selectedAddon, matchesData, addOnProduct, selectedAddon['productHandle'], addonProductMatchData, addonProductMatchData);
                if(incompatible == true){
                    let matchingVariant = addOnProduct.variants[0]
                    if(addonProductMatchData.length > 0){
          
                      let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(addonProductMatchData, selectProductOptions, addOnProduct);
                      matchingVariant = addOnProduct['variants'].find(variant =>
                          Object.entries(matchCriteriaObject).every(([index, values]) =>
                              values.includes(variant.options[index])
                          )
                      );
                      let addonsContainerItem = document.querySelector(`#main-product-item-${product.id} .addons__container .addons .item input[data-addon-id="${addOnProduct.id}"]`).closest('.item');
                      if(matchingVariant && matchingVariant.featured_image && addonsContainerItem){
                            window.Branch.product.updateAddonTile(addonsContainerItem, matchingVariant);
                      }

                      selectedAddons[selectedAddonIndex] = {"productHandle": selectedAddon['productHandle'], "quantity": selectedAddon['quantity'], "variantId": `${matchingVariant.id}`, "shipping": `${msbdData[`${matchingVariant.id}`]}`, "bundle": selectedAddon.bundle, "bundleConstituents": selectedAddon.bundleConstituents, "mainProductQuantity": selectedAddon.mainProductQuantity} 
                      document.querySelectorAll(`.addons-variants .item[data-addon-handle="${selectedAddon['productHandle']}"] .swatch-element input[type="radio"]`).forEach((addonInput) => {
                        addonInput.checked = false;
                      });
                      let newVariantInput = document.querySelector(`.addons-variants .item[data-addon-handle="${selectedAddon['productHandle']}"] .swatch-element input[type="radio"][value="${matchingVariant.id}"]`);
                      if(newVariantInput){newVariantInput.checked = true};
                    }
                }
            });
            document.querySelector('#addon-products-for-atc').setAttribute('value', JSON.stringify(selectedAddons));
            document.querySelector('#addon-products-for-atc').value = JSON.stringify(selectedAddons);


            
        }
    }
    if(document.querySelectorAll('.swatches-container__tab-outer-container .amount-selected').length > 0){
        document.querySelectorAll('.swatches-container__tab-outer-container .amount-selected').forEach((amountSelected) => {
            amountSelected.innerHTML = selectedAddons.length;
        })
        
    }
}

window.Branch.product.updateAddonThumbnailsToMatchSelectedVariant = function(product, variant){
    let addonsContainerItems = document.querySelectorAll(`#main-product-item-${product.id} .addons__container .addons .item`)
    if(addonsContainerItems.length > 0){
    let matchesData = document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`) && document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML ? JSON.parse(document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML) : [];
    let addOnData = document.querySelector(`#add_on_product_data--${product.id}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${product.id}`).innerHTML) : {};
     
    let selectProductOptions = {};
      if(product.options.length > 0){
        product.options.forEach((option, index) => {
          let value = variant.options[index];
          selectProductOptions[`${option}`] = value; 
        })
      }
      if(matchesData.length > 0 && Object.values(addOnData).length > 0){
        addonsContainerItems.forEach((addonsContainerItem) => {
            let checked = addonsContainerItem.querySelector(`#addon-${addonsContainerItem.querySelector('.checkbox-custom-label').getAttribute('data-addon-id')}`).checked;
            if(checked == false){


            let addOnProductHandle = addonsContainerItem.querySelector(`.checkbox-custom-label`).getAttribute('data-addon-handle');
            let addOnProductId = parseInt(addonsContainerItem.querySelector(`.checkbox-custom-label`).getAttribute('data-addon-id'));

            let addonProductMatchData = matchesData.find(entry => entry['add-on-handle'] === addOnProductHandle);
            let addOnProduct = addOnData[`${addOnProductId}`];
            if(addOnProduct) {
                let matchingVariant = addOnProduct.variants[0]
                if(addonProductMatchData){
                    addonProductMatchData = addonProductMatchData[`variant-matches`];
    
                    let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(addonProductMatchData, selectProductOptions, addOnProduct);
                    matchingVariant = addOnProduct['variants'].find(variant =>
                        Object.entries(matchCriteriaObject).every(([index, values]) =>
                            values.includes(variant.options[index])
                        )
                    );
                }
                if(matchingVariant && matchingVariant.featured_image && parseInt(addonsContainerItem.getAttribute('data-display-variant')) != matchingVariant.id){
                    window.Branch.product.updateAddonTile(addonsContainerItem, matchingVariant);
                }
            }
            }
        })
        }
    }
}

const updateOptionsInSelector = function(selectorIndex, item, optionsMap, optionsMapAll) {
    let selectors = item.querySelectorAll(".single-option-selector")
    let selector;
    let key;

    switch (selectorIndex) {
        case 0:
            key = "root";
            selector = selectors[0];
            break;
        case 1:
            key = selectors[0].value;
            selector = selectors[1];
            break;
        case 2:
            key = selectors[0].value;
            key += " / " + selectors[1].value;
            selector = selectors[2];
            break;
    }
    
    let initialValue = selector.value;
    selector.innerHTML = ""; // Clear the existing options
    
    let options = optionsMapAll[key];
    if (options) {
        options.forEach(function(option) {
            let newOption = document.createElement("option");
            newOption.value = option;
            newOption.innerHTML = option;
            selector.appendChild(newOption);
        });
    }
    
    let availableOptions = optionsMap[key];
    let existingOptions = optionsMapAll[key];
    
    if (availableOptions && availableOptions.indexOf(initialValue) !== -1) {
        selector.value = initialValue;
    }
    
        let selected_variant_array = key.split(" / ");
        let swatches = item.querySelectorAll(".swatch");

        if(swatches.length > selected_variant_array.length){
            let finalSwatchValueCurrent = swatches[swatches.length - 1].querySelector('.swatch-element.selected') ? swatches[swatches.length - 1].querySelector('.swatch-element.selected').getAttribute('data-value') : undefined;
            if(finalSwatchValueCurrent && existingOptions && existingOptions.includes(finalSwatchValueCurrent)){
                selected_variant_array.push(finalSwatchValueCurrent);
            } else if(existingOptions) {
                selected_variant_array.push(existingOptions[0]);
            }
        }

        if(selected_variant_array.length == swatches.length){
            item.setAttribute('data-variant-description', `${selected_variant_array}`)
        }

    item.querySelectorAll('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').forEach(function(element) {
        const dataValue = element.getAttribute("data-value");
    
        if (existingOptions && existingOptions.includes(dataValue)) {
            element.removeEventListener('click', handleClick);
    
            if (availableOptions && availableOptions.includes(dataValue)) {
                element.classList.remove("soldout");
                element.querySelector("input[type='radio']").removeAttribute("checked");
                element.querySelector('.tooltip').textContent = dataValue;
            } else {
                if (!item.closest('.template-product-chat-with-sales')) {
                    element.classList.add("soldout");
                    element.querySelector("input[type='radio']").removeAttribute("checked");
                    element.querySelector('.tooltip').textContent = 'Out of stock';
                }
    
                if (window.Branch.functions.isTouchDevice()) {
                    element.addEventListener('click', handleClick);
                }
            }
    
            element.querySelector('input').disabled = false;
            element.classList.remove("option-not-available");
        } else {
            element.querySelector('input').disabled = true;
            element.querySelector('.tooltip').textContent = 'Not available';
            element.classList.add("option-not-available");
    
            if (window.Branch.functions.isTouchDevice()) {
                element.addEventListener('click', handleClick);
            }
        }
    });

    function handleClick() {
        if(tooltip.closest('.swatches-container').getAttribute('data-display-type') == 'tabs'){
            const originalTooltip = this.querySelector('.tooltip');
            const rect = originalTooltip.getBoundingClientRect();

            const floatingTooltip = originalTooltip.cloneNode(true);
            floatingTooltip.classList.add('mobile-display');

            floatingTooltip.style.position = 'absolute';
            floatingTooltip.style.top = `${rect.top}px`;
            floatingTooltip.style.left = `${rect.left}px`;
            floatingTooltip.style.width = `${rect.width}px`; 
            floatingTooltip.style.pointerEvents = 'none';
            floatingTooltip.style.zIndex = '9999';

            document.body.appendChild(floatingTooltip);

            setTimeout(() => {
                floatingTooltip.remove();
            }, 2000);
        } else {
            const tooltip = this.querySelector('.tooltip');
            tooltip.classList.add('mobile-display');
            setTimeout(function() {
                tooltip.classList.remove('mobile-display');
            }, 2000);
        }
}
    
    if (availableOptions && availableOptions.indexOf(initialValue) !== -1) {
        selector.value = initialValue;
    }
};

window.Branch.product.linkOptionSelectors = function(product, item) {
    let optionsMap = {};
    let optionsMapAll = {};
    let selectors = item.querySelectorAll(".single-option-selector")

    product.variants.forEach(variant => {
        optionsMapAll.root = optionsMapAll.root || [];
        optionsMapAll.root.push(variant.option1);
        optionsMapAll.root = Shopify.uniq(optionsMapAll.root);

        if (product.options.length > 1) {
            let key = variant.option1;
            optionsMapAll[key] = optionsMapAll[key] || [];
            optionsMapAll[key].push(variant.option2);
            optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }

        if (product.options.length === 3) {
            let key = variant.option1 + " / " + variant.option2;
            optionsMapAll[key] = optionsMapAll[key] || [];
            optionsMapAll[key].push(variant.option3);
            optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }

        if (variant.available) {
            optionsMap.root = optionsMap.root || [];
            optionsMap.root.push(variant.option1);
            optionsMap.root = Shopify.uniq(optionsMap.root);

            if (product.options.length > 1) {
                let key = variant.option1;
                optionsMap[key] = optionsMap[key] || [];
                optionsMap[key].push(variant.option2);
                optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }

            if (product.options.length === 3) {
                let key = variant.option1 + " / " + variant.option2;
                optionsMap[key] = optionsMap[key] || [];
                optionsMap[key].push(variant.option3);
                optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }
        }
    });

    updateOptionsInSelector(0, item, optionsMap, optionsMapAll);
    if (product.options.length > 1) updateOptionsInSelector(1, item, optionsMap, optionsMapAll);
    if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);

    selectors[0].addEventListener('change', function() {
        updateOptionsInSelector(1, item, optionsMap, optionsMapAll);
        if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);
        return true;
    });

    selectors[1].addEventListener('change', function() {
        if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);
        return true;
    });
}

window.Branch.product.setUpSwatchTabsEventListener = function(type){
    function updateSwatchRowsStyling (){
        document.querySelectorAll('#swatches-test:not([data-test-active="false"])  ~ #page .main-product .swatches-container .swatches-container__tab-outer-container').forEach((outerContainer) => {
            if(outerContainer.closest('.swatches-container').getAttribute('data-total-swatches') == 1 && outerContainer.closest('.swatches-container').getAttribute('data-rows-size') == '1'){
                return;
            }
            let maxSwatchContainerHeight = 168;
            if(outerContainer.querySelector('.swatch') && outerContainer.querySelector('.swatch').getAttribute('data-custom-color-swatch-option') == 'false') {
                maxSwatchContainerHeight = 130;
            }
            if (outerContainer.getAttribute('data-status') === 'open') {
            const swatch = outerContainer.querySelector('.swatch');
            if (!swatch) return;
            const inner = outerContainer.querySelector('.swatch-tab-inner');
            if (inner) {
                inner.style.removeProperty('height');
            }

            const swatchHeight = swatch.offsetHeight;
            const contentsHeight = swatchHeight > maxSwatchContainerHeight ? maxSwatchContainerHeight + 42 : 42 + swatchHeight;

             let newTargetContainerHeight = contentsHeight;
            // if(outerContainer.querySelector('.swatch[data-custom-color-swatch-option="true"]')){newTargetContainerHeight = newTargetContainerHeight - 10;}
                
            outerContainer.style.height = `${newTargetContainerHeight}px`;
            if (inner) {
                if(swatchHeight > maxSwatchContainerHeight){
                    inner.style.height = `${contentsHeight - 42 - 16}px`;
                    inner.setAttribute('data-1-line', false)
                } else {    
                    inner.style.removeProperty('height');
                    inner.setAttribute('data-1-line', true);
                    outerContainer.style.height = `${contentsHeight}px`;
                }
                
            }
            }
        });
    }

    function updateSwatchRows() {
        document.querySelectorAll('#swatches-test:not([data-test-active="false"]) ~ #page .main-product .swatches-container .swatches-container__tab-outer-container').forEach((outerContainer) => {
            let container = outerContainer.querySelector('.swatch-tab-inner');
            const swatches = container.querySelectorAll('.swatch-element');
            const rows = new Set();
            swatches.forEach(swatch => {
                rows.add(swatch.offsetTop);
            });

            let rowsCount = rows.size;

            container.closest('.swatches-container__tab-outer-container').setAttribute('data-rows-size', rowsCount);
            if(container.closest('.swatches-container[data-total-swatches="1"]')){
                container.closest('.swatches-container[data-total-swatches="1"]').setAttribute('data-single-swatch-wrapped', `${rowsCount > 1 ? 'true' : 'false'}`);
                if(rowsCount > 1){
                    updateSwatchRowsStyling();
                } else {
                    outerContainer.style.removeProperty('height');
                    container.style.removeProperty('height');
                }
            }
        })
    }

    updateSwatchRows();
    
    document.addEventListener('click', function (event) {
        let target = event.target.closest('.main-product .swatches-container:not([data-initialized="true"])');
        let targetContainer = event.target.closest('.main-product .swatches-container .swatches-container__tab-outer-container');
        let targetButton = event.target.closest('.main-product .swatches-container .swatches-container__tab-outer-container .swatches-container__tab-button');
        let type = 'swatches'
        if(event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="addons"]')) {
            target = event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="addons"]');
            targetContainer = event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="addons"] ');
            targetButton = event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="addons"] .swatches-container__tab-button');
            type = 'addons'
        }
        if(event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="fake-promo-swatch"]')) {
            target = event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="fake-promo-swatch"]');
            targetContainer = event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="fake-promo-swatch"] ');
            targetButton = event.target.closest('.main-product .swatches-container__tab-outer-container[data-type="fake-promo-swatch"] .swatches-container__tab-button');
            type = 'fake-promo-swatch'
        }

        let recognizeClick = document.querySelector('#swatches-test') && document.querySelector('#swatches-test').getAttribute('data-test-active') == 'false' ? false : true;

        if (recognizeClick && target && targetContainer && targetButton) {
            event.preventDefault();
            if(!event.target.closest('.addons')) {
                let action = targetContainer.getAttribute('data-status') == 'closed' ? 'open' : 'closed';

                if (action === 'open') {
                    const allOpenContainers = document.querySelectorAll('.main-product .swatches-container:not([data-total-swatches="1"]) .swatches-container__tab-outer-container[data-status="open"],  #swatches-test[data-addons-position="within_tabs"]:not([data-test-active="false"]) ~ #page .main-product .swatches-container .swatches-container__tab-outer-container[data-status="open"], .main-product .swatches-container__tab-outer-container[data-type="addons"][data-status="open"], .main-product .swatches-container__tab-outer-container[data-type="fake-promo-swatch"][data-status="open"]');
                    allOpenContainers.forEach(openContainer => {
                        if (openContainer !== targetContainer) {
                            openContainer.setAttribute('data-status', 'closed');
                            openContainer.style.height = '42px';
                            if (openContainer.querySelector('.swatch-tab-inner')) {
                                openContainer.querySelector('.swatch-tab-inner').style.removeProperty('height');
                            }
                        }
                    });
                }
            let maxSwatchContainerHeight = 168;
            if(targetContainer.querySelector('.swatch') && targetContainer.querySelector('.swatch').getAttribute('data-custom-color-swatch-option') == 'false') {
                maxSwatchContainerHeight = 130;
            }
            if(targetContainer.querySelector('.swatch') && !targetContainer.querySelector('.swatch').classList.contains('color')) {
                maxSwatchContainerHeight = 180;
            }
            if(action == 'closed'){
                let targetContainerHeight = targetContainer.offsetHeight > maxSwatchContainerHeight + 16 ? maxSwatchContainerHeight + 16 : targetContainer.offsetHeight;
                targetContainer.style.height = `${targetContainerHeight}px`;
            }  
            setTimeout(function() {
                let contentsHeight;
                if(type == 'swatches'){
                    contentsHeight = action == 'closed' ? 42 : targetContainer.querySelector('.swatch').offsetHeight > maxSwatchContainerHeight ? maxSwatchContainerHeight + 42 : 42 + targetContainer.querySelector('.swatch').offsetHeight;
                } else if(type == 'addons') {
                    contentsHeight = action == 'closed' ? 42 : 42 + targetContainer.querySelector('.addons__container ').offsetHeight;
                    if(action != 'closed'){
                        if(targetContainer.querySelector('.addons__container').getAttribute('data-carousel-quantity') == '1'){
                            contentsHeight = contentsHeight + 30;
                        }        
                    }
                } else {
                    contentsHeight = action == 'closed' ? 42 : 42 + targetContainer.querySelector('.pdp-fake-promo-swatch ').offsetHeight + 20;
                }

                if(!document.querySelector('body.template-page-bundles') && !document.querySelector('body.template-product-bundle')){
                    targetContainer.setAttribute('data-status', action);
                    targetContainer.style.height = `${contentsHeight}px`;
                    if(action == 'closed') {
                        if(targetContainer.querySelector('.swatch-tab-inner')){
                            targetContainer.querySelector('.swatch-tab-inner').style.removeProperty('height');
                        }
                    } else {
                        if(targetContainer.querySelector('.swatch') && targetContainer.querySelector('.swatch-tab-inner')){
                            if(targetContainer.querySelector('.swatch').offsetHeight > maxSwatchContainerHeight){
                                targetContainer.querySelector('.swatch-tab-inner').style.height = `${contentsHeight - 42 - 16}px`;
                                targetContainer.querySelector('.swatch-tab-inner').setAttribute('data-1-line', false)
                            } else {
                                targetContainer.querySelector('.swatch-tab-inner').style.removeProperty('height');
                                targetContainer.querySelector('.swatch-tab-inner').setAttribute('data-1-line', true);
                                targetContainer.style.height = `${contentsHeight + 10}px`;
                            }
                        } 
                    }   
                }       
            }, 1)
            }
        }
    });

    

   let resizeTimeout;

    window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
            updateSwatchRows();
            updateSwatchRowsStyling();
        }, 250);
    });

    let recognizeClick = document.querySelector('#swatches-test') && document.querySelector('#swatches-test').getAttribute('data-test-active') == 'false' ? false : true;
    let firstButton = document.querySelector('.main-product .swatches-container .swatches-container__tab-button[data-clickable="true"]');
    
    if (firstButton && recognizeClick) {
        const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        firstButton.dispatchEvent(event);
    }

     window.Branch.product.removeOverlayFromSwatches = function(productId) {
        let mainProductSwatches = document.querySelectorAll('.main-product .swatch');
        let totalWithParent = 0;
        mainProductSwatches.forEach((swatch) => {
            if(swatch.closest(`body .swatches-container[data-product-id="${productId}"]`)){
                totalWithParent++;
            }
        });

        let processedWithParent = 0;
        mainProductSwatches.forEach((mainProductSwatch, index) => {
            let parent = mainProductSwatch.closest(`body .swatches-container[data-product-id="${productId}"]`)
            if(parent){
                processedWithParent++;
                if(parent.getAttribute('data-click-allowed') != 'true' && parent.getAttribute('data-click-allowed-transition') != 'true' && processedWithParent === totalWithParent){
                    parent.setAttribute('data-click-allowed-transition', true);

                    setTimeout(() => {
                        parent.setAttribute('data-click-allowed', true);
                        parent.removeAttribute('data-click-allowed-transition');
                    }, 500);
                }
            }
        })
    }

    if(document.querySelector('.main-product__item[data-quick-view="false"] .add-to-cart-form')) {
        let productId = parseInt(document.querySelector('.main-product__item[data-quick-view="false"] .add-to-cart-form').getAttribute('data-product-id'));
        window.Branch.product.removeOverlayFromSwatches(productId);
    }

    function createSwiperFromSwatches(swatchElementsData) {
        const swiper = document.createElement('div');
        swiper.className = 'swiper swatch-modal__swiper';

        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = 'swiper-wrapper swatch-modal__swiper-wrapper';
        swiper.appendChild(swiperWrapper);

        Object.entries(swatchElementsData).forEach(([swatchHandle, swatchData]) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide swatch-modal__slide';
            slide.dataset.swatchHandle = swatchHandle;

            const slideInner = document.createElement('div');
            slideInner.className = 'swatch-modal__slide-inner';

            if (swatchData.swatch_image_url) {
                const img = document.createElement('img');
                img.src = swatchData.swatch_image_url.replaceAll('height=100','height=600').replaceAll('width=100','width=600');
                img.alt = swatchHandle;
                slideInner.appendChild(img);
            } else if (swatchData.swatch_gradient_into_second_color) {
                let decodedCss;
                if(swatchData.swatch_tertiary_gradient_color){
                    decodedCss = `background:-moz-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%, ${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_tertiary_gradient_color_rgb} 51%, ${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: -webkit-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_tertiary_gradient_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: linear-gradient(135deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_tertiary_gradient_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${swatchData.swatch_color}', endColorstr='${swatchData.swatch_gradient_into_second_color}',GradientType=1 );`
                } else {
                    decodedCss = `background:-moz-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%, ${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_gradient_into_second_color_rgb} 51%, ${swatchData.swatch_gradient_into_second_color_rgb} 51%, ${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: -webkit-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: linear-gradient(135deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${swatchData.swatch_color}', endColorstr='${swatchData.swatch_gradient_into_second_color}',GradientType=1 );`
                }
                slideInner.setAttribute('style', decodedCss);
            } else {
                slideInner.style.backgroundColor = swatchData.swatch_color;
            }

            slide.appendChild(slideInner);
            swiperWrapper.appendChild(slide);
        });

        return swiper;
        }

    function openSwatchModal(target, targetSwatch, targetSwatchGroup) {
        let targetSwatchIndex = 0;
        if(targetSwatch){
            targetSwatchIndex = parseInt(targetSwatch.getAttribute('data-swatch-index'));
        }
        
        const modal = document.createElement('div');
        modal.classList.add('swatch-modal-overlay');

        const modalBox = document.createElement('div');
        modalBox.classList.add('swatch-modal-box');
        modalBox.setAttribute('data-initialized', false);

        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '&times;';
        closeBtn.classList.add('swatch-modal-close');

        const content = document.createElement('div');
        content.className = "swatch-modal__content"

        let swatchElementsData = {};

        targetSwatchGroup.querySelectorAll('script.swatch-element-data[type="application/ld+json"]').forEach(script => {
            try {
                const data = JSON.parse(script.textContent.trim());

                if (data && data.swatch_handle) {
                const { swatch_handle, ...rest } = data;
                swatchElementsData[swatch_handle] = rest;
                }
            } catch (err) {
                console.error('Failed to parse swatch-element-data JSON:', err, script);
            }
        });


        const swiperElement = createSwiperFromSwatches(swatchElementsData);
        content.appendChild(swiperElement);

        content.innerHTML = `
        ${content.innerHTML}
        <div class="swatch-modal__nav-left swiper-button-prev" data-animate-slide-in="true">
            <svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32">
                <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
            </svg>
        </div>
        <div class="swatch-modal__nav-right swiper-button-next" data-animate-slide-in="true">
            <svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32">
                <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
            </svg>
        </div>
        <div class="swatch-modal__text-container" data-animate-slide-in="true">
            <div class="swatch-modal__swatch-info-container">
                <span class="swatch-modal__swatch-name">${Object.entries(swatchElementsData)[0][1].option_name}:</span>
                <span class="swatch-modal__swatch-value">${Object.entries(swatchElementsData)[0][1].option_value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>
            </div>
            <div class="swatch-modal__counter-container">
                <span class="swatch-modal__swatch-index">1</span>/${Object.entries(swatchElementsData).length}
            </div>
        </div>
        `;

        modalBox.appendChild(closeBtn);
        modalBox.appendChild(content);
        modal.appendChild(modalBox);
        document.body.appendChild(modal);


        // Store swatchElementsData globally for resize handler
        window.currentSwatchElementsData = swatchElementsData;

        // Equalize heights of swatch info containers
        updateSwatchModalHeight(modalBox, swatchElementsData);

        var swatchSlider = null;
        if(Object.entries(swatchElementsData).length > 0){
            swatchSlider = new Swiper('.swatch-modal-box .swiper.swatch-modal__swiper', {
                spaceBetween: 0,
                freeMode: false,
                preventClicks : true,
                a11y: false,
                navigation: {
                    prevEl: '.swatch-modal-box .swatch-modal__nav-left',
                    nextEl: '.swatch-modal-box .swatch-modal__nav-right',
                },
                on: {
                    slideChange: function () {
                        document.querySelector('.swatch-modal__swatch-value').innerHTML = `${Object.entries(swatchElementsData)[this.realIndex][1].option_value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`
                        document.querySelector('.swatch-modal__swatch-index').innerHTML = `${this.realIndex + 1}`
                    },
                    init: function () {
                        this.slideTo(targetSwatchIndex, 0, false);
                        setTimeout(function(){
                            document.querySelectorAll('.swatch-modal-box .swatch-modal__nav-left, .swatch-modal-box .swatch-modal__nav-right').forEach((navArrow) => {
                                navArrow.setAttribute('data-animated', true);
                            });
                            setTimeout(function(){
                                document.querySelector('.swatch-modal__text-container').setAttribute('data-animated', true);
                                setTimeout(function(){
                                    // document.querySelector('.swatch-modal-box').setAttribute('data-initialized', true);
                                }, 250)
                            }, 250)
                        }, 250)
                    },
                },
            })
        }
       
        function closeModal() {
            document.body.removeChild(modal);
            if(swatchSlider){
                swatchSlider.destroy(true, true)
            }
        }

        closeBtn.addEventListener('click', closeModal);
        modal.addEventListener('click', function (e) {
            if (e.target === modal) closeModal();
        });
    }

    document.addEventListener('click', function (event) {
        let recognizeClick = document.querySelector('#swatches-test') && document.querySelector('#swatches-test').getAttribute('data-test-active') == 'false' ? false : true;
        const target = event.target.closest('.main-product .swatches-container .swatch__search-icon-container');
        
        if (target && recognizeClick) {
            event.preventDefault();
            const targetSwatch = target.closest('.main-product .swatches-container .swatch-element');
            const targetSwatchGroup = target.closest('.main-product .swatches-container .swatch');
            openSwatchModal(target, targetSwatch, targetSwatchGroup);
        }
    });
}

var mptof_id;
var mainProductWindowWidth;

window.addEventListener("load", function() {
    window.Branch.product.formatSwatches()
    initMainProductSection();
    initEpigraphButtons();
    repositionPromoSwatchesContainer();
    formatReviewsNumber();
    mainProductWindowWidth = window.innerWidth;
    window.Branch.product.formatPreOrderSwatch();
    window.Branch.product.setUpSwatchTabsEventListener('main');
    checkSizeSwatchesInline();
});

window.addEventListener("resize", function() { 
    clearTimeout(mptof_id); 
    mptof_id = setTimeout(function(){
        if (window.innerWidth != mainProductWindowWidth) {
            mainProductWindowWidth = window.innerWidth
            mainProductReformat();

            // Update swatch modal height on resize if modal is open
            const activeModal = document.querySelector('.swatch-modal-box');
            updateSwatchModalHeight(activeModal);
        }
    }, 500); 
}); 
